const requests = {};

/**
 * @type {Object}
 */
GLOBAL.Xhr = Static( /** @lends Xhr */ {
    prefix: '',
    cache: true,
    /**
     * Constructor.
     */
    initialize: function() {
        this.prefix = GLOBAL.XHR_PREFIX || this.prefix;
        this.cache = GLOBAL.XHR_CACHE != null ? GLOBAL.XHR_CACHE : this.cache;

        $.ajaxSetup({
            dataType: "text",
            type: "GET",
            async: true,
            cache: this.cache
        });
    },

    args: function(args, clone) {
        var self = this;

        args = Util.object(args);

        if (clone) {
            args = Util.clone(args);
        }

        Util.each(args, function(value, name) {
            if (value === null) {
                delete args[name];
            } else if (typeof(value) == "object") {
                Xhr.args(value);
            } else if (value === true) {
                args[name] = 1;
            } else if (value === false) {
                args[name] = "";
            }
        });

        return args;
    },

    request: function (options, callback) {
        if (typeof(options) == "string") {
            options = {
                url: options
            };

//            options.async = !!callback;
        }

        options = Util.object(options);

        var prefix = Util.coalesce(options.prefix, this.prefix, "");

        if (!options.url) {
            return false;
        }

        options.url = prefix + options.url;
        const reqHash = Util.String.hash(options.url + Util.Object.hash(options) + '');

        const onSuccess = data => {
            if (Util.isFunction(callback)) {
                callback(data);
            }

            return data;
        };

        const onError = error => {
            if (Util.isFunction(callback)) {
                callback(null, error);
            }

            throw error;
        };

        const onComplete = data => {
            delete requests[reqHash];

            return data;
        };

        if (requests[reqHash]) {
            requests[reqHash] = requests[reqHash].then(onSuccess).catch(onError);

            return requests[reqHash];
        }

        requests[reqHash] = Promise.resolve($.ajax(options))
            .then(onSuccess)
            .catch(onError)
            .finally(onComplete);

        return requests[reqHash];
    },

    upload: function(options, callback) {
        if (!options || typeof(options) != "object") {
            return false;
        }

        if (!options.file || !options.file.files || !options.file.files.length || !options.filename) {
            return false;
        }

        var form = new FormData();

        if (!options.multiple) {
            form.append(options.filename, options.file.files[0]);
        } else {
            Util.each(options.file.files, function(file, i) {
                form.append(options.filename + "[" + i + "]", file);
            });
        }

        if (options.data && typeof(options.data) == "object") {
            Util.each(options.data, function(value, name) {
                form.append(name, value);
            });
        }

        options.type = "POST";
        options.dataType = "json";
        options.data = form;
        options.contentType = false;
        options.processData = false;

        var requestCallback = null;

        if (Util.isFunction(callback)) {
            requestCallback = function(data, error) {
                if (error) {
                    callback({
                        success: false,
                        data: null,
                        message: "Request failed",
                        code: -1
                    });
                } else {
                    callback(data);
                }
            };
        }

        return this.request(options, requestCallback);
    },

    call: function(url, args, callback, method) {
        if (Util.isFunction(args)) {
            callback = args;
            args = null;
        }

        var options = {
            url: url,
//            async: !!callback,
            type: method || "GET",
            dataType: "json",
            data: args,
            single: true
        };

        var requestCallback = null;

        if (Util.isFunction(callback)) {
            requestCallback = function(data, error) {
                if (error) {
                    callback({
                        success: false,
                        data: null,
                        message: "Request failed",
                        code: -1
                    });
                } else {
                    callback(data);
                }
            };
        }

        return this.request(options, requestCallback);
    },

    doCall: function(url, params, done, callback) {
        if (callback) {
            this.call(url, params, function(result) {
                var ret = done(result);

                if (Util.isFunction(callback)) {
                    callback(ret);
                }
            });

            return null;
        } else {
            var result = this.call(url, params);
            return done(result);
        }
    },

    doUpload: function(options, done, callback) {
        if (callback) {
            this.upload(options, function(result) {
                var ret = done(result);

                if (Util.isFunction(callback)) {
                    callback(ret);
                }
            });

            return null;
        } else {
            var result = this.upload(options);
            return done(result);
        }
    },

    appendAjaxPrefilter: function() {
        $.ajaxPrefilter(function(options, originalOptions, jqXHR) {
            options.beforeSend = function(jqXHR) {
                jqXHR.setRequestHeader("X-Requested-With", "XMLHttpRequest");
            };
        });
    },

    appendDataPrefilter: function(callback, context) {
        $.ajaxPrefilter(function(options, originalOptions, jqXHR) {
            var data = originalOptions.data;

            if (typeof(data) == "string") {
                data = $.deparam(originalOptions.data);
            } else if (!data || typeof(data) != "object") {
                data = {};
            }

            Util.call(callback, context, [data]);

            options.data = $.param(data);
        });
    },

    alert: function(message, response) {
        if (response && Util.isObject(response)) {
            if (!response.success && Util.isDefined(response.code) && Util.isDefined(response.message)) {
                message += "\n\nКод: " + response.code + "\nСообщение: " + response.message;
            }
        }

        alert(message);
    }
});
